import React, { Component } from 'react';
import { withRouter } from 'react-router'

class Unauthorized extends Component {

  render() {
    return (
      <div>
      	<h1>Unauthorized</h1>

      </div>
    );
  }
}

export default withRouter(Unauthorized);


// WEBPACK FOOTER //
// ./src/components/auth/Unauthorized.js